import PropTypes from 'prop-types';
import ToolTip, {tooltipPositions} from '../ToolTip.jsx';

import React from 'react';

import EditableSelectField from '../forms/editableSelectField.jsx';

class LayoutSelect extends React.Component {
  static defaultProps = {
    condition: true,
    editMode: true,
    keys: [],
    label: '',
    options: [],
  };

  static propTypes = {
    'data-event-action': PropTypes.string,
    'data-event-category': PropTypes.string,
    className: PropTypes.string,
    condition: PropTypes.bool,
    dataChanged: PropTypes.func,
    dataKey: PropTypes.string,
    editMode: PropTypes.bool,
    group: PropTypes.object,
    keys: PropTypes.array,
    label: PropTypes.string,
    options: PropTypes.array,
    optionsChange: PropTypes.bool,
    required: PropTypes.bool,
    tooltip: PropTypes.string,
    validate: PropTypes.func,
    validateMessage: PropTypes.any,
    value: PropTypes.any,
    noLabel: PropTypes.bool,
  };

  state = {
    value: this.props.value,
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.value !== this.props.value) {
      this.setState({
        value: nextProps.value,
      });
    }
  }

  onChange = ({key, value}) => {
    if (this.props.dataChanged) {
      this.props.dataChanged({key, value});
    }

    this.setState({
      value,
    });
  };

  getValue = () => {
    return this.state.value;
  };

  focus = () => {
    if (this.refs.inner) {
      this.refs.inner.focus();
    }
  };

  highlight = () => {
    this.refs.inner.highlight();
  };

  render() {
    let output = null;

    if (this.props.condition) {
      output =
        <div className={this.props.className ? 'form-group ' + this.props.className : 'form-group'}>
          {!this.props.noLabel ? <label>
            {this.props.label}
            {this.props.required && this.props.editMode ? <span className='error' style={{marginLeft: 2}}>*</span> : null}
            {this.props.tooltip ? <ToolTip title={this.props.tooltip} position={tooltipPositions.topRight} iconOnly /> : null}
          </label> : null}
          <EditableSelectField ref='inner'
            {...this.props}
            onChange={this.onChange}
            value={this.state.value || this.state.value === 0 ? this.state.value : ''}
             />
        </div>
      ;
    }
    return output;
  }
}

export default LayoutSelect;
